import { Stack } from '@mui/material';
import ContactsList from './ContactsList';
import UserList from './UsersList';

function UsersAndContacts() {
  return (
    <Stack direction="column" spacing={4}>
      <UserList />
      <ContactsList />
    </Stack>
  );
}

export default UsersAndContacts;
